module.exports = __webpack_public_path__ + "img/NAR-1.bc4a9466.png";